import { render, staticRenderFns } from "./ResourcesView.vue?vue&type=template&id=215e5d8f&scoped=true&"
import script from "./ResourcesView.vue?vue&type=script&lang=js&"
export * from "./ResourcesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215e5d8f",
  null
  
)

export default component.exports